import React, { useCallback } from 'react';

import { CloseFill } from '@lyearn/icons';
import { TypographyWithTooltip } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { LinkButton, Stack } from '@lyearn/ui';
import { FilterOption } from '@/components/Filter/types';

type SelectedWorkspaceProps = {
  selectedWorkspace: FilterOption;
  onRemove: (id: string) => void;
  disabled?: boolean;
};
const TOOLTIP_CLASSES = {
  tooltip: 'ps-16 pe-12 pt-12 pb-16 max-w-[24rem]',
};

function SelectedWorkspace(props: SelectedWorkspaceProps) {
  const { selectedWorkspace, onRemove, disabled } = props;
  const { label, value } = selectedWorkspace;
  const _onRemove = useCallback(() => {
    onRemove(value);
  }, [onRemove, value]);

  return (
    <Stack
      alignItems="center"
      className={cn(
        'h-40 flex-shrink-0 rounded-8 border border-interactive-secondary-hover pe-8 ps-12 overflow-hidden max-w-full',
        {
          'cursor-not-allowed opacity-50': disabled,
        },
      )}
      gapX={4}
      justifyContent="between">
      <TypographyWithTooltip classes={TOOLTIP_CLASSES} numberOfLines={1} variant="body-short-02">
        {label}
      </TypographyWithTooltip>
      <LinkButton
        className="py-2 px-4 ps-0 pe-0 max-w-[1.5rem]"
        color={'internal'}
        disabled={disabled}
        onClick={disabled ? undefined : _onRemove}>
        <CloseFill />
      </LinkButton>
    </Stack>
  );
}

export default SelectedWorkspace;
